import { TooltipIconButton } from "@components/Atoms/TooltipIconButton";
import { useAgentChatVisibility } from "@ext/agent/components/hooks/useAgentChatVisibility";
import { AgentSettingsModal } from "@ext/agent/components/panel/AgentSettingsModal";
import { ChatDropdown } from "@ext/agent/components/panel/ChatDropdown";
import { setAgentChatIsOpen } from "@ext/agent/components/store/AgentChatIsOpenStore";
import t from "@ext/localization/locale/translate";
import { Icon } from "@ui-kit/Icon";
import { Label } from "@ui-kit/Label";
import { memo, useState } from "react";
import { useApiKey } from "../store/AgentStore";
import { useChatHeaderActions } from "../store/ChatStore";

export const ChatHeader = memo(() => {
	const { sessions, activeSessionId, onSelectSession, onCloseTab, onNewSession, onSaveSettings } =
		useChatHeaderActions();
	const [settingsOpen, setSettingsOpen] = useState(false);
	const apiKey = useApiKey();
	const { showGear } = useAgentChatVisibility();

	return (
		<>
			<div className="flex min-h-10 max-w-full min-w-0 items-center gap-0.5 justify-between px-4 pt-2">
				<div className="flex items-center gap-2">
					<Icon icon="wand-sparkles" />
					<Label>{t("agent.panel-name")}</Label>
				</div>
				<div className="flex gap-1">
					<ChatDropdown
						activeId={activeSessionId}
						onClose={onCloseTab}
						onNew={onNewSession}
						onSelect={onSelectSession}
						sessions={sessions}
					/>
					{showGear && (
						<TooltipIconButton
							className="p-1"
							icon="settings"
							iconClassName="size-3.5"
							onClick={() => setSettingsOpen(true)}
							size="xs"
							tooltip={t("agent.tooltips.settings")}
							variant="ghost"
						/>
					)}
					<TooltipIconButton
						className="p-1"
						icon="x"
						iconClassName="size-3.5"
						onClick={() => setAgentChatIsOpen(false)}
						size="xs"
						tooltip={t("agent.tooltips.close")}
						variant="ghost"
					/>
				</div>
			</div>
			<AgentSettingsModal
				defaultKey={apiKey ?? ""}
				onOpenChange={setSettingsOpen}
				onSave={(key) => onSaveSettings?.(key)}
				open={settingsOpen}
			/>
		</>
	);
});
